// extracted by mini-css-extract-plugin
export var active = "_g0-7";
export var blink = "_g0-8";
export var dropDownSelector = "_g0-4";
export var dropDownWrapper = "_g0-3";
export var fakeCursor = "_g0-6";
export var fontSizeButton = "_g0-9";
export var formQuillEditor = "_g0-0";
export var pressed = "_g0-a";
export var qlBlank = "_g0-1";
export var textFormattingToolbar = "_g0-2";
export var textToolbarOption = "_g0-5";